import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./../auth.service";
import { first } from "rxjs/operators";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    this.authService.getIsLoggedIn().then(status => {
      if (!status) {
        this.router.navigate(["account/login"]);
      }
    });

    return this.authService.getIsLoggedIn();
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/guards/auth.guard.ts